define('controllers/registration',['require'],function(require) {
	return function() {		
	    window.validateCheckedMemberAgreement = function (sender, args) {
            if (args != null) {
                args.IsValid = $("#chkMemberAgreement").is(':checked');
            }
		}

		//check username
		$("#txtUsername").on("change", function () {
			var checkingUserName = $("#checkingUserName"),
				userNameInUse = $("#userNameInUse"),
				$this = $(this),
				userName = $this.val().trim();

			userNameInUse.hide();
			$this.removeAttr("style");

			if (userName.length > 0) {
				checkingUserName.show();

				$.ajax({
					type: 'POST',
					url: "UserNameCheckAJAX.aspx",
					data: { UserName: userName },
					success: function (response) {
						response === "True" ? $this.css({ border: "1px solid #3A87AD" }) : userNameInUse.show();
						checkingUserName.hide();
					},
					error: function () {
						checkingUserName.hide();
					}
				});
			}
		});

		setOnBeforeUnLoad();

		var btnContinue = $("#btnContinue");
		btnContinue.on("click", function (e) {
			window.onbeforeunload = null;
			btnContinue_jsClick(e);
		});

		function btnContinue_jsClick(e) {
			if (window.Page_ClientValidate == undefined || Page_ClientValidate('AccountInformationStep')) {
				btnContinue.hide();
				$('#loading').fadeIn('slow');
				gaTrack('conversions', 'activated', $('#txtEmail').val(), 0);
			} else {
				e.preventDefault();
				setOnBeforeUnLoad();
			}
		}

		function setOnBeforeUnLoad() {
			window.onbeforeunload = function (e) {
				return "You have unsaved changes.";
			};
		}

		Utilities.setDefaultButton($("#registrationForm"), btnContinue);
	};
});
